import React from "react";
import { Text } from "@hangar/web-components/core/Text";
import { ConfigExample } from "../../components/config/ConfigExample";
import { Container, Paper, Code } from "./ConfigurationExample.styles";

/**
 * Página que muestra la configuración MSAL
 * Endpoint: /config-example
 */
export const ConfigurationExample: React.FC = () => {
  return (
    <Container>
      <Text variant="heading-lg">Configuración</Text>
      <Text variant="body-md">
        Esta página muestra la configuración del archivo JSON y MSAL (Microsoft Authentication
        Library) de la aplicación. La configuración se carga dinámicamente desde archivos JSON y
        puede incluir variables de entorno específicas para cada ambiente.
      </Text>

      {/* Configuration MSAL Component */}
      <Paper>
        <ConfigExample />
      </Paper>

      {/* Additional Information */}
      <Text variant="heading-md">Información Adicional</Text>
      <Text variant="body-md">
        Esta configuración MSAL muestra cómo implementar un sistema de autenticación flexible que
        puede ser actualizado sin necesidad de recompilar la aplicación. La configuración se carga
        desde
        <Code>/assets/config/configuration.json</Code> y se puede personalizar para diferentes
        entornos.
      </Text>
      <Text variant="body-md">
        Para más información sobre la configuración MSAL, consulta la documentación en el
        repositorio.
      </Text>
    </Container>
  );
};
